import { AddProject, initialState} from './add-project.state';
import { AddProjectActions, AddProjectActionType } from './add-project.actions';

export function addProjectReducer(state = initialState, action: AddProjectActions): AddProject {
    switch (action.type) {
        case AddProjectActionType.InitAddProject:

            return {
                ...state, 
                data:  {
                    info: '',
                    due_date: null,
                    files: [],
                    labels: [],
                    version: action.versionId,
                    workflow: action.workflowId
                },
                errors: initialState.errors,
                savedProject: null,
                creatingNewProject: false,
                saved: false
            };

        case AddProjectActionType.UpdateAddProject:
            return { ...state, data: { ...state.data, ...action.property } };

        case AddProjectActionType.Clear:
            return { ...state, data: null, errors: initialState.errors, savedProject: null, creatingNewProject: false, saved: false };

        case AddProjectActionType.SetErrors:
            return { ...state, errors: { ...state.errors, ...action.errors } };

        case AddProjectActionType.ClearErrors:
            return { ...state, errors: initialState.errors };

        case AddProjectActionType.SubmitAddProject:
            return { ...state, creatingNewProject: true, saved: false }; // Set creating flag when submission starts

        case AddProjectActionType.SubmitAddProjectSuccess:
            return {
                ...state,
                savedProject: action.project, // Store the created project here
                creatingNewProject: false,    // Reset creating flag
                saved: true,                  // Mark as saved
                errors: initialState.errors   // Clear errors on success
            };

        case AddProjectActionType.SubmitAddProjectFailure:
            return { ...state, creatingNewProject: false }; // Reset creating flag on failure, errors handled in effect

        default:
            return state;
    }
}